<template>
  <div class="supplier">

  <template>
  <v-card class="mt-4"
    :loading="loading"
    >
    <v-card-title>
       <h1 class="mr-2 subheading grey--text">Υπόλοιπο</h1>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>

    <v-card-text ma=4>
    <h2 class="ma-2 subheading grey--text">Ενηλικίωση Υπόλοιπου</h2>
    <v-data-table
      :headers="headers"
      :items="balances"
      :search="search"
      sort-by="Date"
      sort-desc
      loading: false
      class="elevation-1"
      :loading="loading"
      loading-text="Loading... Please wait"
    >

     <template v-slot:item.actions="{ item }">
        <v-btn
          icon
          @click.stop="showdialog(item)"
        >
         <v-icon>mdi-information-variant</v-icon>
        </v-btn>
     </template>
    <template v-slot:body.append="{headers}">
        <tr>
            <td v-for="(header,i) in headers" :key="i">

                <div class="text-right" v-if="header.value == 'Balance'">
                    Σύνολο: {{ $tocurr(totalBalance) }}
                </div>

                <div v-else>
                    <!-- empty table cells for columns that don't need a sum -->
                </div>

            </td>
        </tr>
    </template>

    <template v-slot:item.Balance="{ item }">
       {{ new Intl.NumberFormat('el-GR', { style: 'currency', currency: 'EUR' }).format(item.Balance) }}
    </template>
     <template v-slot:expanded-item="{ headers, item }">
      <td :colspan="headers.length">
        More info about {{ item.DocNumber }}
      </td>
    </template>
    </v-data-table>
      </v-card-text>
  </v-card>
</template>


  </div>
</template>

<script>

export default {
 computed: {
      totalBalance() {
        return this.balances.reduce((a, b) => a + (b.Balance|| 0), 0);
      },
  },
  data() {
    return {
      balances: [{Dates: "", Balance: 0 }],
      loading: true,
      search: '',
      supplier_id: this.$route.params.id,
      debits: [],
      headers: [
          { text: 'Διάστημα', value: 'Dates', align: 'start' },
          { text: 'Υπόλοιπο', value: 'Balance', align: 'end' },
        ],
    }
  },
  async created() {
      try {
        const response = await this.$api.get('/suppliers/balance-view/'+this.supplier_id);
        //console.log(response);
        this.balances = response.data
        this.loading = false;
      } catch (error) {
        console.error(error);
      }
    },
watch: {
      timdialog (val) {
        val || this.close()
      },
},
  methods: {
  showdialog(item) {
    //console.log(item, this.timdialog)
    this.diaitems = item.line_items;
    this.timdialog = true;
  },
  close () {
        this.timdialog = false
  }

  }
}
</script>
